import { render, staticRenderFns } from "./IntegrationStep1.vue?vue&type=template&id=486a8db0&"
import script from "./IntegrationStep1.vue?vue&type=script&lang=js&"
export * from "./IntegrationStep1.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationStep1.vue?vue&type=style&index=0&id=486a8db0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports